(function(){
  function ready(fn){if(document.readyState!=='loading'){fn()}else{document.addEventListener('DOMContentLoaded',fn)}}
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(scope){
    if(reduce||!('IntersectionObserver' in window))return;
    var els=[].slice.call(scope.querySelectorAll('.mgb[data-animate] .mgb-r'));
    if(!els.length)return;
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('mgb-in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px',threshold:.06});
    els.forEach(function(el){io.observe(el)});
    function fb(){var vh=window.innerHeight;els.forEach(function(el){if(el.classList.contains('mgb-in'))return;var r=el.getBoundingClientRect();if(r.top<vh&&r.bottom>0){el.classList.add('mgb-in');io.unobserve(el)}})}
    fb();setTimeout(fb,400);setTimeout(fb,1400);window.addEventListener('load',fb);
  }

  function initFilters(scope){
    [].slice.call(scope.querySelectorAll('[data-mgb-filterable]')).forEach(function(root){
      if(root.__mgbInit)return;root.__mgbInit=true;
      var pills=[].slice.call(root.querySelectorAll('[data-mgb-tag]'));
      var cards=[].slice.call(root.querySelectorAll('[data-mgb-card]'));
      var empty=root.querySelector('[data-mgb-empty]');
      pills.forEach(function(p){
        p.addEventListener('click',function(){
          var tag=p.getAttribute('data-mgb-tag');
          pills.forEach(function(o){o.classList.remove('on');o.setAttribute('aria-pressed','false')});
          p.classList.add('on');p.setAttribute('aria-pressed','true');
          var shown=0;
          cards.forEach(function(c){
            var ok=tag==='all'||(c.getAttribute('data-tags')||'').indexOf('|'+tag+'|')>-1;
            if(ok){c.removeAttribute('hidden');shown++}else{c.setAttribute('hidden','')}
          });
          if(empty)empty.style.display=shown?'none':'block';
        });
      });
    });
  }

  function initAll(scope){initReveals(scope||document);initFilters(scope||document)}
  ready(function(){initAll(document)});
  document.addEventListener('shopify:section:load',function(e){initAll(e.target)});
})();
